import { MessageCircle } from "lucide-react";

export function ChatWelcome() {
  return (
    <div className="mx-auto flex min-h-0 w-full max-w-[60rem] flex-1 flex-col overflow-y-auto px-6 md:px-8">
      <div className="my-auto flex shrink-0 flex-col items-center pt-10 pb-12 text-center">
        <div className="bg-muted mb-6 flex size-12 items-center justify-center rounded-2xl">
          <MessageCircle className="size-6 stroke-[1.5]" />
        </div>
        <h1 className="text-foreground max-w-lg text-3xl leading-tight font-medium tracking-[-0.035em] md:text-4xl">
          What can LawWorks assist with
        </h1>
      </div>
    </div>
  );
}
